import { FilterData, OPERATORS, OperatorData } from "../../types/filter";
import { Column } from "./DataTable";
import { Filters } from "./Filter";

export function parseFilterUrl(
  fields: Column[],
  location: Pick<Location, 'search'>
): Filters {
  let filtersResult: Filters = {};

  const allParams: string[] =
    (location && location.search.substr(1).split('&')) || [];

  const paramFilter: string =
    allParams.find(param => param.startsWith('filters')) || '';

  const params: string[] = paramFilter.split('==') || [];
  const filtersUrl: string = params[1];
  const filtersSplit: string[] = filtersUrl ? filtersUrl.split(';') : [];
    
  filtersSplit.forEach((f: string) => {
    const nameValue: string[] = f.split('=');

    const name: string = nameValue[0].split('_')[0];
    const field: Column | undefined = fields.find(f => f.label === decodeURI(name));
    const operatorUrl: string = decodeURIComponent(nameValue[0].split('_')[1]);
    let value: string | object = decodeURIComponent(nameValue[1]);
    
    if (field) {
      const operator: OperatorData | undefined = OPERATORS[field.type||'STRING'].find(
        o => o.name === operatorUrl
      );
      if (operator) {
        filtersResult = {
          ...filtersResult,
          [`${name}_${operatorUrl}`]: {
            value,
            column: field,
            operator
          }
        };
      }
    }
  });

  return filtersResult;
}

export function buildFilterToUrl(
  filters: Filters,
  currentSearchParams: string
): string {
  const remainingSearchParams = currentSearchParams
    .substr(currentSearchParams.startsWith('?') ? 1 : 0)
    .split('&')
    .filter(searchClause => !searchClause.startsWith('filters'))
    .filter(searchClause => !searchClause.startsWith('page'))
    .join('&');

  if (Object.keys(filters).length === 0) {
    return remainingSearchParams;
  }

  const newFilter: string = Object.entries(filters)
    .map(([key, filter]: [string, any]) => {
      let value = filter.value;
      return `${key}=${encodeURIComponent(value)}`;
    })
    .join(';');

  const parsedFilter = newFilter ? `filters==${newFilter}` : '';

  return remainingSearchParams === ''
    ? parsedFilter
    : `${remainingSearchParams}&${parsedFilter}`;
}

export const buildFilterRsql = (filters: Filters): string => {
    let searchParams = '';

    Object.entries(filters)
        .map(([key, filter]: [string, FilterData]) => {
            if (searchParams) {
                searchParams += ';';
            }

            let value = typeof filter.value === 'string'
                ? encodeURIComponent(filter.value)
                : filter.value;

            if (!filter.column.type || filter.column.type === 'STRING') {
                if (filter.operator.name === 'Contém') {
                    value = `'*${value}*'`;
                }
            } else if (filter.column.type === 'DATE') {
                value = `"${value}"`;
            } else if (filter.column.type === 'BOOLEAN') {
                // Na URL fica sim/nao; na API, true/false
                value = value === 'sim' ? 'true' : 'false';
            }

            searchParams += filter.column.field + filter.operator.symbol + decodeURIComponent(value);
        });

    return searchParams;
}